import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
// import useSignalR from "hooks/useSignalR";

// project imports
import useAuth from "hooks/useAuth";
import { useEffect } from "react";

// import { SNACKBAR_OPEN } from "store/actions";
// import jwtDecode from "jwt-decode";
// import { useDispatch, useSelector } from "react-redux";

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
  const { isLoggedIn } = useAuth();
  // const { commonHub } = useSignalR();
  const navigate = useNavigate();
  // const { clientId } = useSelector((state) => state.appReducer);
  // const [newClientId, setNewClientId] = useState(clientId);
  // const dispatch = useDispatch();

  // const getConnectionMessages = async () => {
  //   try {
  //     if (!commonHub) return;
  //     if (commonHub?.state !== "Connected") {
  //       await commonHub.start();
  //     }
  //     commonHub.on("GetConnectionId", async (message) => {
  //       setNewClientId(message?.ConnectionId);
  //     });

  //     commonHub.on("DisconnectCurrentUser", async (message) => {
  //       if (!message?.Success) {
  //         dispatch({
  //           type: SNACKBAR_OPEN,
  //           open: true,
  //           message: message?.Message,
  //           variant: "alert",
  //           alertSeverity: "success",
  //         });
  //         logout();
  //         await commonHub.stop();
  //       }
  //     });
  //     commonHub.on("SessionControl", async (message) => {
  //       if (message?.Success) {
  //         dispatch({
  //           type: SNACKBAR_OPEN,
  //           open: true,
  //           message: message?.Message,
  //           variant: "alert",
  //           alertSeverity: "success",
  //         });
  //         logout();
  //         await commonHub.stop();
  //       }
  //     });
  //   } catch (err) {
  //     window.console.error("Get Connection  Messages Error --> ", err);
  //   }
  // };

  // const controlConnected = async () => {
  //   try {
  //     if (!localStorage.getItem("serviceToken")) return;
  //     const decoded = jwtDecode(localStorage.getItem("serviceToken"));
  //     const userEmail = decoded?.systemUserEmail ?? "";
  //     if (newClientId || (clientId && isLoggedIn)) {
  //       if (!!clientId) {
  //         await commonHub.invoke("OnSuccessConnected", clientId, userEmail, "MedMasraf");
  //         localStorage.setItem("client_id", clientId);
  //       } else {
  //         await commonHub.invoke("OnSuccessConnected", newClientId, userEmail, "MedMasraf");
  //         localStorage.setItem("client_id", newClientId);
  //       }
  //     }
  //   } catch (err) {
  //     dispatch({
  //       type: SNACKBAR_OPEN,
  //       open: true,
  //       message: `Kullanıcının yetkisi bulunamadı`,
  //       variant: "alert",
  //       alertSeverity: "error",
  //     });
  //     logout();
  //     await commonHub.stop();
  //   }
  // };

  // useEffect(() => {
  //   if (isLoggedIn) {
  //     getConnectionMessages();
  //   }
  // }, [isLoggedIn]);

  // useEffect(() => {
  //   if (localStorage.getItem("serviceToken")) {
  //     controlConnected();
  //   }
  // }, [newClientId, isLoggedIn, clientId]);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("login", { replace: true });
    } else {
    }
  }, [isLoggedIn, navigate]);

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
